import Dog1 from '../../public/assets/recipes/categories/review-1.webp'
import Dog2 from '../../public/assets/recipes/categories/review-2.webp'
import Dog3 from '../../public/assets/recipes/categories/review-3.webp'
import Dog4 from '../../public/assets/recipes/categories/review-4.webp'
import Dog5 from '../../public/assets/recipes/categories/review-5.webp'
import Dog6 from '../../public/assets/recipes/categories/review-6.webp'
import Dog7 from '../../public/assets/recipes/categories/review-7.webp'
import Dog8 from '../../public/assets/recipes/categories/review-8.webp'
import Dog9 from '../../public/assets/recipes/categories/review-9.webp'
import Dog10 from '../../public/assets/recipes/categories/review-10.webp'
import Dog11 from '../../public/assets/recipes/categories/review-11.webp'
import Dog12 from '../../public/assets/recipes/categories/review-12.webp'
import Dog13 from '../../public/assets/recipes/categories/review-13.webp'
import Dog14 from '../../public/assets/recipes/categories/review-14.webp'
import Dog15 from '../../public/assets/recipes/categories/review-15.webp'
import Dog16 from '../../public/assets/recipes/categories/review-16.webp'
import Dog17 from '../../public/assets/recipes/categories/review-17.webp'
import Dog18 from '../../public/assets/recipes/categories/review-18.webp'
import Dog19 from '../../public/assets/recipes/categories/review-19.webp'
import Dog20 from '../../public/assets/recipes/categories/review-20.webp'
import Dog21 from '../../public/assets/recipes/categories/review-21.webp'
import Dog22 from '../../public/assets/recipes/categories/review-22.webp'
import Dog23 from '../../public/assets/recipes/categories/review-23.webp'
import Dog24 from '../../public/assets/recipes/categories/review-24.webp'

import { StaticImageData } from 'next/image'
import { TranslationKeys } from 'locales/translationKeys'

type ReviewItem = {
  name: string
  message: string
}

export const DUMMY_REVIEWS: ReviewItem[] = [
  {
    name: 'John Doe',
    message: 'First review',
  },
  {
    name: 'Jane Doe',
    message: 'Second review',
  },
  {
    name: 'Jim Doe',
    message: 'Third review',
  },
]

export type ProductReviewType = {
  name: AuthorType
  owner: TranslationKeys
  comment: TranslationKeys
  image: StaticImageData
}

export type ReviewType = {
  owner: TranslationKeys
  comment: TranslationKeys
  headline: TranslationKeys
  tag: Tag 
}

export type Tag =
  | 'all'
  | 'mealtime excitement'
  | 'weight management'
  | 'longevity'
  | 'healthy coat'
  | 'better digestion'

export type AuthorType =
  | 'seth'
  | 'melissa'
  | 'mariah'
  | 'sunny'
  | 'julie'
  | 'cristin'
  | 'barbara'
  | 'autumn'
  | 'diana'
  | 'lori'
  | 'nena'
  | 'ashley'
  | 'rachel'
  | 'rebekah'
  | 'norman'
  | 'peter'
  | 'darlene'
  | 'jen'
  | 'mallia'
  | 'jev'
  | 'teresa'
  | 'anu'
  | 'katie'
  | 'valerie'

export const ProductPageReviews: Record<AuthorType, ProductReviewType> = {
  katie: {
    name: 'katie',
    owner: 'reviews:productPage.katie.owner',
    comment: 'reviews:productPage.katie.comment',
    image: Dog24,
  },
  barbara: {
    name: 'barbara',
    owner: 'reviews:productPage.barbara.owner',
    comment: 'reviews:productPage.barbara.comment',
    image: Dog6,
  },
  mallia: {
    name: 'mallia',
    owner: 'reviews:productPage.mallia.owner',
    comment: 'reviews:productPage.mallia.comment',
    image: Dog19,
  },
  diana: {
    name: 'diana',
    owner: 'reviews:productPage.diana.owner',
    comment: 'reviews:productPage.diana.comment',
    image: Dog8,
  },
  anu: {
    name: 'anu',
    owner: 'reviews:productPage.anu.owner',
    comment: 'reviews:productPage.anu.comment',
    image: Dog22,
  },
  mariah: {
    name: 'mariah',
    owner: 'reviews:productPage.mariah.owner',
    comment: 'reviews:productPage.mariah.comment',
    image: Dog2,
  },
  peter: {
    name: 'peter',
    owner: 'reviews:productPage.peter.owner',
    comment: 'reviews:productPage.peter.comment',
    image: Dog16,
  },
  teresa: {
    name: 'teresa',
    owner: 'reviews:productPage.teresa.owner',
    comment: 'reviews:productPage.teresa.comment',
    image: Dog21,
  },
  ashley: {
    name: 'ashley',
    owner: 'reviews:productPage.ashley.owner',
    comment: 'reviews:productPage.ashley.comment',
    image: Dog11,
  },
  darlene: {
    name: 'darlene',
    owner: 'reviews:productPage.darlene.owner',
    comment: 'reviews:productPage.darlene.comment',
    image: Dog17,
  },
  rachel: {
    name: 'rachel',
    owner: 'reviews:productPage.rachel.owner',
    comment: 'reviews:productPage.rachel.comment',
    image: Dog12,
  },
  sunny: {
    name: 'sunny',
    owner: 'reviews:productPage.sunny.owner',
    comment: 'reviews:productPage.sunny.comment',
    image: Dog3,
  },
  valerie: {
    name: 'valerie',
    owner: 'reviews:productPage.valerie.owner',
    comment: 'reviews:productPage.valerie.comment',
    image: Dog23,
  },
  rebekah: {
    name: 'rebekah',
    owner: 'reviews:productPage.rebekah.owner',
    comment: 'reviews:productPage.rebekah.comment',
    image: Dog13,
  },
  jev: {
    name: 'jev',
    owner: 'reviews:productPage.jev.owner',
    comment: 'reviews:productPage.jev.comment',
    image: Dog20,
  },
  julie: {
    name: 'julie',
    owner: 'reviews:productPage.julie.owner',
    comment: 'reviews:productPage.julie.comment',
    image: Dog4,
  },
  seth: {
    name: 'seth',
    owner: 'reviews:productPage.seth.owner',
    comment: 'reviews:productPage.seth.comment',
    image: Dog14,
  },
  autumn: {
    name: 'autumn',
    owner: 'reviews:productPage.autumn.owner',
    comment: 'reviews:productPage.autumn.comment',
    image: Dog7,
  },
  lori: {
    name: 'lori',
    owner: 'reviews:productPage.lori.owner',
    comment: 'reviews:productPage.lori.comment',
    image: Dog9,
  },
  melissa: {
    name: 'melissa',
    owner: 'reviews:productPage.melissa.owner',
    comment: 'reviews:productPage.melissa.comment',
    image: Dog1,
  },
  nena: {
    name: 'nena',
    owner: 'reviews:productPage.nena.owner',
    comment: 'reviews:productPage.nena.comment',
    image: Dog10,
  },
  jen: {
    name: 'jen',
    owner: 'reviews:productPage.jen.owner',
    comment: 'reviews:productPage.jen.comment',
    image: Dog18,
  },
  cristin: {
    name: 'cristin',
    owner: 'reviews:productPage.cristin.owner',
    comment: 'reviews:productPage.cristin.comment',
    image: Dog5,
  },
  norman: {
    name: 'norman',
    owner: 'reviews:productPage.norman.owner',
    comment: 'reviews:productPage.norman.comment',
    image: Dog15,
  },
}
